import React from "react";
import { EditorSerializer } from "@smartsuite/smartdoc";
import { type EditorSerializerProps } from "@smartsuite/smartdoc/lib/esm/react/EditorSerializer/EditorSerializer";

const HTMLBlockSerializer: React.FC<EditorSerializerProps> = (props) => {
  return <EditorSerializer {...props} />;
};

export default HTMLBlockSerializer;
